import qc from 'qc'
import { scripts } from '@ps/bridge/qc/scripts/index'

export interface aspectRatioFitterData {
  mode: number; // 当值为 0 时，不会自动调整
}

export const getScript = (node: qc.Node, addScriptIfScriptNotExist = true): aspectRatioFitterData | undefined => {
  const config: aspectRatioFitterData = node.getScript(scripts.qcAspectRatioFitter.name)
  if (config) {
    return config
  }
  if (addScriptIfScriptNotExist) {
    return node.addScript(scripts.qcAspectRatioFitter.name) as aspectRatioFitterData
  }
}
